// src/auth/AuthCallback.js
import React, { useEffect } from 'react';

const AuthCallback = () => {
  useEffect(() => {
    // The redirect promise is already handled in index.js before the app renders.
    // This component just needs to redirect to the main app.
    // The authentication state should already be set by MSAL.
    
    console.log('AuthCallback: Redirecting to main app...');
    
    // Small delay to show success message, then redirect (preserve query e.g. ?share= from URL or sessionStorage)
    const timer = setTimeout(() => {
      // If the user was bounced here by the backend redirect on a protected
      // URL (e.g. /api/websites/...), LoginPage stashed the validated `next`
      // path. Re-validate here as defense-in-depth before navigating to it.
      const nextPath = sessionStorage.getItem('auth_return_next');
      if (nextPath) {
        sessionStorage.removeItem('auth_return_next');
        const safe = nextPath.startsWith('/')
          && !nextPath.startsWith('//')
          && !nextPath.startsWith('/\\');
        if (safe) {
          window.location.href = nextPath;
          return;
        }
      }

      // Same idea, for a DIFFERENT trip through here: an MSAL
      // acquireTokenRedirect interactive-reauth mid-session (see
      // AuthContext.js) is a real cross-page navigation through this
      // component, which otherwise always lands back on plain "/" and
      // loses whichever conversation/project the user was actually on.
      // App.js mirrors its current canonical path into this key on every
      // change (see LAST_APP_PATH_STORAGE_KEY/computeCanonicalPath there)
      // specifically so this fallback has somewhere to read it back from --
      // not removed (unlike auth_return_next above) since it's meant to
      // keep reflecting wherever the user is, not be consumed once.
      const lastAppPath = sessionStorage.getItem('kai_last_app_path');
      if (lastAppPath) {
        const safe = lastAppPath.startsWith('/')
          && !lastAppPath.startsWith('//')
          && !lastAppPath.startsWith('/\\');
        if (safe && lastAppPath !== '/') {
          window.location.href = lastAppPath;
          return;
        }
      }

      let search = window.location.search || '';
      const savedQuery = sessionStorage.getItem('auth_return_query');
      if (savedQuery) {
        sessionStorage.removeItem('auth_return_query');
        search = savedQuery;
      }
      window.location.href = '/' + search;
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '400px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          backgroundColor: '#107c10',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1rem',
          color: 'white',
          fontSize: '20px'
        }}>
          ✓
        </div>
        <h2 style={{ color: '#333', marginBottom: '0.5rem' }}>Authentication Successful!</h2>
        <p style={{ color: '#666', margin: 0 }}>Redirecting you to the application...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
